"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const bridge_1 = require("@completeanatomy/bridge");
const infobox_1 = require("@completeanatomy/infobox");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const react_transition_group_1 = require("react-transition-group");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const licenses_1 = require("@completeanatomy/licenses");
const atoms_1 = require("../../atoms");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const hooks_1 = require("../../hooks");
const useStateReducer_1 = require("../../hooks/useStateReducer");
const useToolsState_1 = require("../../hooks/useToolsState");
const MainScreenStateProvider_1 = require("../../providers/MainScreenStateProvider");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
function SecondaryToolbar({ isSearchOpen, onClickSearch, onClickDescription, isLabelsOpen, onClickLabelsButton, onClickReset, isDescriptionOpen, closeDescriptionButtonRef, }) {
    var _a, _b, _c, _d;
    const bridge = (0, bridge_1.useBridge)();
    const isUndoActive = (0, models_1.useUndoActive)();
    const isRedoActive = (0, models_1.useRedoActive)();
    const isResetActive = (0, models_1.useResetScreenActive)();
    const [hideButtons, setHideButtons] = (0, react_1.useState)(isLabelsOpen);
    const licenses = (0, licenses_1.useUserLicenses)();
    const screenInfo = (0, hooks_1.useScreenInfo)();
    const toolsState = (0, useToolsState_1.useToolsState)();
    const descriptionButtonRef = (0, react_1.useRef)(null);
    const foolScreenButtonRef = (0, react_1.useRef)(null);
    const lastFocusedElementRef = (0, react_1.useRef)(null);
    const isLandscape = (0, ui_1.useOrientation)();
    const selectedPart = (0, models_1.useSelectedPart)();
    const { isActive: isMultiSelectActive, isRedoActive: isRedoActiveMultiselect, isUndoActive: isUndoActiveMultiselect, } = (0, infobox_1.useMultiSelectState)();
    const [{ currentTab }, dispatch] = (0, MainScreenStateProvider_1.useMainScreenStateContext)();
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    const isHideTab = currentTab === useStateReducer_1.TabType.Hide;
    const isCopyAvailable = licenses === null || licenses === void 0 ? void 0 : licenses.some(license => license.type > bridge_schema_1.LicenseType.StudentPlus);
    const isUndoAvailable = isMultiSelectActive
        ? isUndoActiveMultiselect
        : isUndoActive;
    const isRedoAvailable = isMultiSelectActive
        ? isRedoActiveMultiselect
        : isRedoActive;
    const shouldShowIfLower = isLower && !isLandscape;
    const shouldShowCopy = isCopyAvailable && shouldShowIfLower && !isHideTab;
    const shouldShowDescription = screenInfo.information && shouldShowIfLower && !isHideTab;
    const shouldShowFullToolbar = !(isLower && selectedPart.identifier);
    const shouldShowHideToolbarsButton = !isLower || !selectedPart.identifier || isHideTab;
    const shouldShowLabels = !!((_b = (_a = toolsState === null || toolsState === void 0 ? void 0 : toolsState.labelsState) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.length) ||
        !!((_d = (_c = toolsState === null || toolsState === void 0 ? void 0 : toolsState.stickiesState) === null || _c === void 0 ? void 0 : _c.stickies) === null || _d === void 0 ? void 0 : _d.length);
    const tooltipPosition = isLower ? 'right' : 'bottom';
    (0, react_1.useEffect)(() => {
        setHideButtons(isLabelsOpen);
    }, [isLabelsOpen]);
    const onClick = (state) => {
        return () => {
            if (state === useStateReducer_1.TabType.Description) {
                onClickDescription();
            }
            dispatch((0, useStateReducer_1.selectTab)(state));
        };
    };
    const onHideToolbar = () => {
        lastFocusedElementRef.current = document.activeElement;
        dispatch((0, useStateReducer_1.selectTab)(useStateReducer_1.TabType.Hide));
    };
    const onUndo = (0, react_1.useCallback)(() => {
        isMultiSelectActive
            ? bridge === null || bridge === void 0 ? void 0 : bridge.multipleSelectionUndoAction()
            : bridge === null || bridge === void 0 ? void 0 : bridge.historyUndoPressed();
    }, [bridge, isMultiSelectActive]);
    const onRedo = (0, react_1.useCallback)(() => {
        isMultiSelectActive
            ? bridge === null || bridge === void 0 ? void 0 : bridge.multipleSelectionRedoAction()
            : bridge === null || bridge === void 0 ? void 0 : bridge.historyRedoPressed();
    }, [bridge, isMultiSelectActive]);
    const onLongPress = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.historyUndoAllPressed();
    };
    const onLabelClick = () => {
        onClickLabelsButton();
    };
    const onCopyLink = () => {
        navigator.clipboard.writeText(window.location.href);
    };
    const handleTabNavigation = (0, react_1.useCallback)((event) => {
        if (isDescriptionOpen && event.key === 'Tab') {
            const activeElement = document.activeElement;
            const nextButton = activeElement === descriptionButtonRef.current
                ? closeDescriptionButtonRef === null || closeDescriptionButtonRef === void 0 ? void 0 : closeDescriptionButtonRef.current
                : descriptionButtonRef.current;
            nextButton === null || nextButton === void 0 ? void 0 : nextButton.focus();
            event.preventDefault();
        }
    }, [isDescriptionOpen, closeDescriptionButtonRef]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (isDescriptionOpen) {
            (_a = closeDescriptionButtonRef === null || closeDescriptionButtonRef === void 0 ? void 0 : closeDescriptionButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = descriptionButtonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        window.addEventListener('keydown', handleTabNavigation);
        return () => {
            window.removeEventListener('keydown', handleTabNavigation);
        };
    }, [isDescriptionOpen, closeDescriptionButtonRef, handleTabNavigation]);
    (0, react_1.useEffect)(() => {
        if (!isHideTab && lastFocusedElementRef.current) {
            lastFocusedElementRef.current.focus();
            lastFocusedElementRef.current = null;
        }
    }, [isHideTab]);
    return shouldShowFullToolbar || isHideTab ? ((0, jsx_runtime_1.jsxs)(Toolbar, { "$isHided": isHideTab, "$isLabelsOpen": isLabelsOpen, "$isLower": isLower, "$isLandscape": isLandscape, children: [shouldShowFullToolbar && !isHideTab && ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isLabelsOpen, timeout: 600, onEnter: () => setHideButtons(false), onExited: () => setHideButtons(true), children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [shouldShowIfLower && ((0, jsx_runtime_1.jsx)(atoms_1.SearchButton, { isSelected: isSearchOpen, onClick: onClickSearch, tooltipPlace: tooltipPosition })), (0, jsx_runtime_1.jsxs)(HiddenButton, { hideButtons: hideButtons, isLower: isLower, "$isLandscape": isLandscape, children: [(0, jsx_runtime_1.jsx)(atoms_1.UndoButton, { onClick: onUndo, onLongPress: onLongPress, disabled: !isUndoAvailable, tooltipPlace: tooltipPosition }), (0, jsx_runtime_1.jsx)(atoms_1.RedoButton, { onClick: onRedo, disabled: !isRedoAvailable, tooltipPlace: tooltipPosition })] }), (0, jsx_runtime_1.jsx)(atoms_1.ResetButton, { onClick: onClickReset, disabled: !isResetActive, tooltipPlace: tooltipPosition }), shouldShowLabels && ((0, jsx_runtime_1.jsx)(atoms_1.LabelButton, { onClick: onLabelClick, isSelected: isLabelsOpen, tooltipPlace: tooltipPosition }))] }) })), (0, jsx_runtime_1.jsxs)(HiddenButton, { hideButtons: hideButtons, isLower: isLower, "$isLandscape": isLandscape, children: [shouldShowHideToolbarsButton && ((0, jsx_runtime_1.jsx)(atoms_1.HideToolbarsButton, { onClick: onHideToolbar, ref: foolScreenButtonRef })), shouldShowCopy && ((0, jsx_runtime_1.jsx)(atoms_1.CopyLinkButton, { onClick: onCopyLink, tooltipPlace: tooltipPosition })), shouldShowDescription && ((0, jsx_runtime_1.jsx)(atoms_1.DescriptionButton, { onClick: onClick(useStateReducer_1.TabType.Description), tooltipPlace: tooltipPosition, ref: descriptionButtonRef }))] })] }, `secondary-toolbar-${isLower}-${isLandscape}-${isLabelsOpen}`)) : null;
}
exports.default = SecondaryToolbar;
const HiddenButton = styled_components_1.default.div `
  display: ${({ hideButtons, isLower, $isLandscape }) => hideButtons && isLower && !$isLandscape ? 'none' : 'flex'};

  flex-direction: ${({ isLower, $isLandscape }) => isLower && !$isLandscape ? 'column' : 'row'};
`;
const Toolbar = styled_components_1.default.div `
  padding: 4px;
  display: flex;
  gap: 4px;
  background-color: ${({ theme }) => theme.grasshopper.background};
  border-radius: 4px;
  width: fit-content;
  margin-left: ${({ $isHided }) => ($isHided ? 'auto' : '0')};
  transition: max-height 0.6s ease-in-out;
  max-height: ${({ $isLabelsOpen }) => (!$isLabelsOpen ? '500px' : '140px')};
  overflow: hidden;
  z-index: 0;

  box-shadow: ${({ theme }) => `0px 2px 4px 0px ${theme.grasshopper.dropShadow}`};

  flex-direction: ${({ $isLower, $isLandscape }) => $isLower && !$isLandscape ? 'column' : 'row'};
`;
